import InfoBanner from 'components/banners/InfoBanner'
import { useMerchantFeedbackEnabled } from 'hooks/useCurrentMerchant'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('feedbacks.responses')

interface Props {
  className?: string
}

const FeedbackBanner: React.FC<Props> = ({ className = '' }) => {
  const isFeedbackEnabled = useMerchantFeedbackEnabled()

  if (isFeedbackEnabled) {
    return null
  }

  return (
    <div className={className}>
      <InfoBanner text={t('banner.non_thanx_feedback')} showIcon />
    </div>
  )
}

export default FeedbackBanner
